'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
const $ = require("jquery");
class Accordion {
    constructor() {
        if ($('.trigAccordion').length === 0)
            return;
        $('.trigAccordion').on('mouseenter', (e) => {
            const type = $(e.currentTarget).attr('data-type');
            $(`.bulletAccordionList[data-type='${type}']`).stop().slideDown('slow');
            $('.trigAccordion').attr('data-is-open', 'true');
        });
        $('.trigAccordion').on('mouseleave', (e) => {
            const type = $(e.currentTarget).attr('data-type');
            $(`.bulletAccordionList[data-type='${type}']`).stop().slideUp('slow');
            $('.trigAccordion').attr('data-is-open', 'false');
            setTimeout(() => {
                $(`.bulletAccordionList[data-type='${type}']`).css('display', 'none');
            }, 500);
        });
    }
}
exports.Accordion = Accordion;
exports.default = Accordion;
